import { useMemo } from 'react';
import { useStorage } from '@/js/libs/hooks/useStorage';
import { useCallbackRef } from '../../hooks/useCallbackRef';
import { StorageKey } from '../types';
const useTokenStorage = () => {
    const { loadString, saveString, removeItem } = useStorage({ storage: window.localStorage });
    const forgetAuthToken = useCallbackRef(() => removeItem(StorageKey.TOKEN));
    const getAuthToken = useCallbackRef(() => loadString(StorageKey.TOKEN));
    const storeAuthToken = useCallbackRef((token) => saveString(StorageKey.TOKEN, token));
    return useMemo(() => ({
        forgetAuthToken,
        getAuthToken,
        storeAuthToken,
    }), [forgetAuthToken, getAuthToken, storeAuthToken]);
};
export default useTokenStorage;
